var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDownWhite = function SvgChevronDownWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.004 16.004a1 1 0 0 1-.71-.29l-6-6a1.004 1.004 0 1 1 1.42-1.42l5.29 5.29 5.29-5.29a1.004 1.004 0 1 1 1.42 1.42l-6 6a1 1 0 0 1-.71.29"
  })));
};
export default SvgChevronDownWhite;